export default [
  { from: '/en/suppliers', to: '/en/suppliers/dorman' },
  { from: '/fr/fournisseurs', to: '/fr/fournisseurs/dorman' },
  { from: '/en/suppliers/', to: '/en/suppliers/dorman' },
  { from: '/fr/fournisseurs/', to: '/fr/fournisseurs/dorman' },
  { from: '/fr/manuelautoservice/', to: '/fr/manueldoperation/' },
  { from: '/fr/manueldoperation/', to: '/fr/manuelautoparts/' },
  { from: '/en/autoservicemanual/', to: '/en/operationmanual/' },
  { from: '/fr/manuel-exploitation', to: '/fr/manuelautoservice/' },
  { from: '/en/operations-manuals', to: '/en/autoservicemanual/' },
  { from: '/en/Autoxpo', to: 'https://autoxpo.ca/' },
  { from: '/fr/Autoxpo', to: 'https://autoxpo.ca/fr/' },
  { from: '/fr/nos-services', to: '/fr/ressources/service' },
  { from: '/en/our-services', to: '/en/resources/services' },
  { from: '/en/the-brand-difference', to: '/en/about' },
  { from: '/en/services-solutions/for-consumer', to: ' /en/resources/services' },
  { from: '/en/raybestos', to: '/en/brands/raybestos' },
  { from: '/en/rs-parts', to: '/en/brands/rsparts' },
  { from: '/en/worldparts', to: '/en/brands/worldparts' },
  {
    from: '/en/products-and-equipment-group/products-equipments',
    to: '/en/our-products'
  },
  {
    from: '/en/products-and-equipment-group/replacement-parts',
    to: '/en/our-products'
  },
  {
    from: '/en/products-and-equipment-group/fluid',
    to: '/en/our-products'
  },
  {
    from: '/en/products-and-equipment-group/tools',
    to: '/en/our-products'
  },
  {
    from: '/en/products-and-equipment-group/accessories',
    to: '/en/our-products'
  },
  { from: '/content/images/TechTip-ENG.PDF', to: '/en/our-products' },
  {
    from: '/en/products-and-equipment-group/brakes',
    to: '/en/our-products'
  },
  {
    from: '/content/images/Red-Rocket-May-PG-2-2018.pdf',
    to: '/en/our-products/brakes'
  },
  {
    from: '/content/images/Worldparts-Disc-Brake-Rotor.pdf',
    to: '/en/our-products/brakes'
  },
  {
    from: '/content/images/Disque-de-frein-Worldparts.pdf',
    to: '/en/our-products/brakes'
  },
  {
    from: '/en/news-promotions/news?orderBy=sectionId%20asc',
    to: '/en/resources'
  },
  {
    from: '/en/news-promotions/news?orderBy=sectionId%20asc',
    to: '/en/resources'
  },
  {
    from: '/en/news-promotions/news/p8?orderBy=sectionId%20asc',
    to: '/en/resources'
  },
  {
    from: '/en/news-promotions/news/p8?orderBy=sectionId%20asc',
    to: '/en/resources'
  },
  {
    from: '/en/news-promotions/news/p8?orderBy=sectionId%20asc',
    to: '/en/resources'
  },
  {
    from: '/en/news-promotions/news/p8?orderBy=sectionId%20asc',
    to: '/en/resources'
  },
  {
    from: '/en/news-promotions/news/p8?orderBy=sectionId%20asc',
    to: '/en/resources'
  },
  {
    from: '/en/news-promotions/news/p8?orderBy=sectionId%20asc',
    to: '/en/resources'
  },
  {
    from: '/en/news-promotions/news/p8?orderBy=sectionId%20asc',
    to: '/en/resources'
  },
  { from: '/en/news-promotions/promotions', to: '/en/resources' },
  {
    from: '/en/news/2019/kevin-lacroix-bumper-to-bumper-toronto',
    to: '/en/resources'
  },
  { from: '/en/news/2019/lacroix-takes-the-lead', to: '/en/resources' },
  { from: '/en/news/2019/nascar-pintys-next-step', to: '/en/resources' },
  {
    from: '/en/news/2019/autodrome-chaudiere-an-important-race',
    to: '/en/resources'
  },
  {
    from: '/en/news/2019/2nd-podium-of-the-season-for-kevin-lacroix-and-bumper-to-bumper-team-at-jukasa-motor-speedway',
    to: '/en/resources'
  },
  {
    from: '/en/news/2019/nascar-season-2019-schedule',
    to: '/en/resources'
  },
  {
    from: '/en/news/2019/kevin-lacroix-seeks-victory-at-the-gp3r-and-nothing-less',
    to: '/en/resources'
  },
  {
    from: '/en/news/2018/let-the-100th-memorial-cup-begin',
    to: '/en/resources'
  },
  {
    from: '/en/news/2018/the-2018-nascar-season-has-already-started',
    to: '/en/resources'
  },
  {
    from: 'http://bumpertobumper.ca/fr/news/hitting-the-ice-for-the-2017-18-chl-season',
    to: '/en/resources'
  },
  { from: '/en/news/2017/une-culture-gagnante', to: '/en/resources' },
  {
    from: '/en/news/2017/kevin-lacroix-wins-at-circuit-icar',
    to: '/en/resources'
  },
  {
    from: '/en/news/2017/bumper-to-bumper-redonne-a-la-communaute-de-sussex-au-nouveau-brunswick',
    to: '/en/resources'
  },
  {
    from: '/en/news/2017/add-the-pintys-grand-prix-of-toronto-to-the-trophy-list',
    to: '/en/resources'
  },
  {
    from: '/en/news/2016/2016-cibc-canada-russia-series-recap',
    to: '/en/resources'
  },
  {
    from: '/en/news/2016/bumper-to-bumper-announces-sponsorship-deal-with-the-cfl',
    to: '/en/resources'
  },
  { from: '/en/news/2016/kevin-lacroix-top-3-finish', to: '/en/resources' },
  {
    from: '/en/news/2016/kevin-lacroix-returns-to-the-site-of-his-first-career-win',
    to: '/en/resources'
  },
  {
    from: '/en/news/2016/cfl-goes-bumper-to-bumper-into-grey-cup-playoffs',
    to: '/en/resources'
  },
  {
    from: '/en/news/2016/bumper-to-bumpers-driver-behind-the-wheel-this-saturday',
    to: '/en/resources'
  },
  {
    from: '/en/news/2019/innovative-engineering-spectra-premium',
    to: '/en/resources'
  },
  {
    from: '/en/news/2019/philips-exceptional-lighting',
    to: '/en/resources'
  },
  { from: '/en/news/2018/red-rocket-reviered-review', to: '/en/resources' },
  {
    from: '/en/news/2018/la-vague-bumper-to-bumper-se-poursuit',
    to: '/en/resources'
  },
  {
    from: '/en/news/2018/cooling-depot-coolant-keeping-your-cars-cool',
    to: '/en/resources'
  },
  {
    from: '/content/images/12217-US_Circulaire-Nov_Dec-2019_ANG-Est-HR.pdf',
    to: '/en/resources'
  },
  {
    from: '/en/promotion/high-performance-filters-for-new-or-older-engines',
    to: '/en/flyer/'
  },
  {
    from: '/content/images/2019-CE-Monroe-Spring-Consumer-4-1_4-30-REBATE-PAD.pdf',
    to: '/en/flyer/'
  },
  { from: '/content/images/TechTip-FRN.PDF', to: '/en/flyer/' },
  {
    from: 'http://bumpertobumper.ca/content/images/2016-CE-Expert-Plus_100-100-100_Flyer_FINAL.pdf',
    to: '/en/flyer/'
  },
  {
    from: '/content/images/US-Ciculaire-grossiste-Janvier-East-ANG-VF.pdf',
    to: '/en/flyer/'
  },
  {
    from: '/en/promotion/dynomax-get-a-100-mastercard-card',
    to: '/en/flyer/'
  },
  {
    from: '/content/images/12135-US_Circulaire_June-2019_2019_ANG_West-HR.pdf',
    to: '/en/flyer/'
  },
  { from: '/en/chl', to: '/en/flyer/' },
  { from: '/en/become-a-member', to: '/en/for-your-business' },
  {
    from: '/en/services-solutions/for-repair-shops',
    to: '/en/for-your-business'
  },
  { from: '/en/services-solutions/for-stores', to: '/en/for-your-store' },
  { from: '/en/training/warranties', to: '/en/for-your-business' },
  {
    from: '/en/testimonials/graham-prouse-g-o-supply',
    to: '/en/for-your-business'
  },
  { from: '/en/find-a-shop-by-city', to: '/en/find-a-store' },
  {
    from: '/en/find-a-shop-by-city/british-columbia',
    to: '/en/find-a-store'
  },
  { from: '/en/find-a-shop-by-city/alberta', to: '/en/find-a-store' },
  { from: '/en/find-a-shop-by-city/saskatchewan', to: '/en/find-a-store' },
  { from: '/en/find-a-shop-by-city/manitoba', to: '/en/find-a-store' },
  { from: '/en/find-a-shop-by-city/ontario', to: '/en/find-a-store' },
  { from: '/en/find-a-shop-by-city/quebec', to: '/en/find-a-store' },
  {
    from: '/en/find-a-shop-by-city/newfoundland-and-labrador',
    to: '/en/find-a-store'
  },
  { from: '/en/find-a-shop-by-city/nova-scotia', to: '/en/find-a-store' },
  {
    from: '/en/find-a-shop-by-city/northwest-territories',
    to: '/en/find-a-store'
  },
  { from: '/en/find-a-shop-by-city/yukon', to: '/en/find-a-store' },
  { from: '/en/find-a-shop-by-city/new-brunswick', to: '/en/find-a-store' },
  {
    from: '/en/find-a-shop-by-city/prince-edward-island',
    to: '/en/find-a-store'
  },
  {
    from: '/en/store-locator/null/jbs-saltspring-auto-parts-1312',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/british-columbia/ladysmith/bumper-to-bumper-ladysmith-1314',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/british-columbia/chemainus/bumper-to-bumper-chemainus-1403',
    to: '/en/find-a-store'
  },
  {
    from: '/en/store-locator/chemainus/chemainus-auto-parts-1403',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/british-columbia/courtenay/bumper-to-bumper-courtenay-1315',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/british-columbia/fernie/fernie-auto-parts-ltd-1476',
    to: '/en/find-a-store'
  },
  {
    from: '/en/store-locator/fort-nelson/g-o-supply-ltd-1330',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/british-columbia/kamloops/btb-gilbert-supply-company-ltd-5134',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/british-columbia/merritt/btb-gilbert-supply-company-ltd-5135',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/british-columbia/north-vancouver/bumper-to-bumper-main-street-north-vancouver-1298',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/british-columbia/north-vancouver/bumper-to-bumper-1st-street-north-vancouver-1299',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/british-columbia/vancouver/bumper-to-bumper-5th-ave-vancouver-1417',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/british-columbia/penticton/bumper-to-bumper-penticton-1419',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/british-columbia/quesnel/bumper-to-bumper-quesnel-1382',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/british-columbia/saanichton/saanichton-1709-5044',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/british-columbia/vernon/gilbert-supply-company-1994',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/british-columbia/victoria/bumper-to-bumper-government-1313',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/british-columbia/victoria/bumper-to-bumper-gold-stream-ave-1310',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/british-columbia/duncan/bumper-to-bumper-duncan-1402',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/airdrie/btb-par-auto-parts-airdrie-ltd-1374',
    to: '/en/find-a-store'
  },
  {
    from: '/en/store-locator/airdrie/par-auto-parts-airdrie-ltd-1374',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/barrhead/bumper-to-bumper-anderson-auto-parts-supplies-ltd-5144',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/beaverlodge/jrs-sales-rentals-1336',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/bonnyville/wilter-auto-industrial-supply-bonnyville-1337',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/calgary/agi-bumper-to-bumper-calgary-1373',
    to: '/en/find-a-store'
  },
  {
    from: '/en/store-locator/calgary/agi-bumper-to-bumper-calgary-south-1373',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/claresholm/bishoffs-auto-ag-centre-1376',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/cold-lake/bumper-to-bumper-cold-lake-wilter-auto-industrial-supply-1328',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/cremona/bumper-to-bumper-cremona-1377',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/daysland/daysland-auto-farm-supply-1395',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/drayton-valley/brians-automotive-specialists-1329',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/edmonton/agi-bumper-to-bumper-edmonton-1317',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/edmonton/bumper-to-bumper-edmonton-south-1318',
    to: '/en/find-a-store'
  },
  {
    from: '/en/store-locator/edmonton/bumper-to-bumper-edmonton-south-1318',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/edmonton/bumper-to-bumper-roper-rd-edmonton-1633',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/edmonton/btb-thind-brothers-1387',
    to: '/en/find-a-store'
  },
  {
    from: '/en/store-locator/edmonton/thind-brothers-1387?utm_source=G&utm_medium=lpm&utm_campaign=bumpertobumper',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/edmonton/bumper-to-bumper-118th-ave-edmonton-1635',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/edson/bumper-to-bumper-edson-1322',
    to: '/en/find-a-store'
  },
  {
    from: '/en/store-locator/edson/agi-bumper-to-bumper-edson-1322',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/elk-point/wilter-auto-industrial-supply-elk-point-1344',
    to: '/en/find-a-store'
  },
  {
    from: '/en/store-locator/evansburg/woodland-lumber-building-supplies-1406',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/falher/bumper-to-bumper-falher-1415',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/fort-mcmurray/bumper-to-bumper-fort-mcmurray-1642',
    to: '/en/find-a-store'
  },
  {
    from: '/en/store-locator/glendon/dales-auto-industrial-supply-ltd-1323',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/hanna/bumper-to-bumper-hanna-1332',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/innisfail/industrial-ag-supplies-5039',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/lacombe/btb-lacombe-wilter-auto-industrial-supply-1353',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/lethbridge/cep-automotive-ltd-1333',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/lloydminster/wilter-auto-industrial-supply-lloydminster-1334',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/mannville/bauer-auto-tire-ltd-1352',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/mayerthorpe/bumper-to-bumper-mayerthorpe-1425',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/morinville/morinville-bumper-to-bumper-1338',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/nampa/nampa-auto-farm-supply-ltd-1319',
    to: '/en/find-a-store'
  },
  {
    from: '/en/store-locator/nampa/nampa-auto-farm-supply-ltd-gonat-holdings-ltd-1319',
    to: '/en/find-a-store'
  },
  {
    from: '/en/store-locator/olds/motocar-automotive-supply-1339',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/plamondon/cs-auto-inc-1316',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/red-deer/elmac-auto-electric-ltd-1320',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/rocky-mountain-house/rocky-automotive-distributors-ltd-1340',
    to: '/en/find-a-store'
  },
  {
    from: '/en/store-locator/rocky-mountain-house/rocky-automotive-distributors-1340',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/saint-paul/wilter-auto-industrial-supply-st-paul-1343',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/slave-lake/d-t-auto-center-1998-ltd-1341',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/smoky-lake/all-rig-services-ltd-1342',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/stettler/bounty-onsite-inc-1321',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/strathmore/quality-auto-supply-1378',
    to: '/en/find-a-store'
  },
  {
    from: '/en/store-locator/sundre/22-west-ltd-oa-bumper-to-bumper-sundre-1422',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/thorsby/bumper-to-bumper-hankin-st-thorsby-1634',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/three-hills/btb-three-hills-motor-products-ltd-1372',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/two-hills/btb-two-hills-auto-industrial-supply-ltd-1392',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/vegreville/btb-veg-auto-industrial-supply-2013-ltd-1393',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/viking/wainwright-auto-supply-1988-ltd-1349',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/wainwright/wainwright-auto-supply-1988-ltd-1346',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/westlock/first-place-auto-parts-ltd-1347',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/alberta/wetaskiwin/renos-automotive-ltd-5090',
    to: '/en/find-a-store'
  },
  {
    from: '/en/store-locator/whitecourt/downtown-auto-1325',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/saskatchewan/assiniboia/assiniboia-auto-parts-ltd-1441',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/saskatchewan/biggar/yh-truck-ag-auto-5079',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/saskatchewan/cudworth/prairie-parts-plus-ltd-1303',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/saskatchewan/foam-lake/hb-b-agro-sales-1295',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/saskatchewan/foam-lake/bumper-to-bumper-hb-b-agro-sales-5130',
    to: '/en/find-a-store'
  },
  {
    from: '/en/store-locator/foam-lake/hb-b-agro-sales-1295',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/saskatchewan/climax/rv-auto-parts-frontier-1607',
    to: '/en/find-a-store'
  },
  {
    from: '/en/store-locator/frontier/rv-auto-parts-frontier-1607',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/saskatchewan/gravelbourg/l-l-auto-ag-supplies-ltd-1292',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/saskatchewan/hudson-bay/universal-parts-supply-tam-ind-1306',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/saskatchewan/humboldt/1st-stop-auto-parts-ind-supply-inc-1389',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/saskatchewan/kindersley/bumper-to-bumper-kindersley-1305',
    to: '/en/find-a-store'
  },
  {
    from: '/en/store-locator/kindersley/bumper-to-bumper-kindersly-1305',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/saskatchewan/kipling/btb-ok-ag-auto-parts-1427',
    to: '/en/find-a-store'
  },
  {
    from: '/en/store-locator/langenburg/lc-auto-ag-supply-ltd-1293',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/saskatchewan/macklin/macklin-auto-centre-1994-1300',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/saskatchewan/meadow-lake/extreme-speed-rv-ltd-1307',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/saskatchewan/moose-jaw/sutherland-automotive-2223',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/saskatchewan/north-battleford/sutherland-automotive-5053',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/saskatchewan/prince-albert/sutherland-automotive-2036',
    to: '/en/find-a-store'
  },
  {
    from: '/en/store-locator/prince-albert/lonestar-parts-2036',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/saskatchewan/rocanville/lc-auto-ag-ltd-1294',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/saskatchewan/saskatoon/sutherland-automotive-2183',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/saskatchewan/shaunavon/rv-auto-parts-shaunavon-1304',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/saskatchewan/swift-current/great-west-auto-electric-ltd-1483',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/saskatchewan/yorkton/yorkton-ag-auto-supply-1297',
    to: '/en/find-a-store'
  },
  {
    from: '/en/store-locator/lafleche/jasons-agri-motive-parts-supply-1296',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/manitoba/ashern/northern-lites-auto-farm-supply-1280',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/manitoba/beausejour/beausejour-tire-ltd-1281',
    to: '/en/find-a-store'
  },
  {
    from: '/en/store-locator/beausejour/beausejour-tire-ltd-1281',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/manitoba/lundar/danielsons-bumper-to-bumper-1282',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/manitoba/swan-river/swan-valley-auto-ltd-1291',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/manitoba/winnipeg/auto-parts-central-inc-1287',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/manitoba/winnipeg/auto-parts-central-inc-1288',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/ontario/london/bumper-to-bumper-exeter-rd-london-1429',
    to: '/en/find-a-store'
  },
  {
    from: '/en/store-locator/new-hamburg/bh-mcfarlane-1407',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/ontario/north-bay/bumper-to-bumper-he-brown-supply-1397',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/ontario/owen-sound/bumper-to-bumper-owen-sound-1431',
    to: '/en/find-a-store'
  },
  {
    from: '/en/store-locator/sioux-lookout/sioux-per-auto-parts-inc-1290',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/ontario/sudbury/leroux-auto-parts-1644',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/ontario/sunderland/bumper-to-bumper-sunderland-1423',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/ontario/terrace-bay/bumper-to-bumper-terrace-bay-1285',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/ontario/thunder-bay/auto-parts-central-inc-1286',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/ontario/thunder-bay/auto-parts-central-inc-1289',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/ontario/uxbridge/btb-uxbridge-1424',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/ontario/woodstock/wismers-auto-parts-plus-1381',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/quebec/alma/bumper-to-bumper-alma-1383',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/quebec/baie-saint-paul/bumper-to-bumper-la-malbaie-a-baie-st-paul-1379',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/quebec/boisbriand/pieces-dauto-lacroix-inc-1659',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/quebec/east-angus/pieces-dautos-angus-1640',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/quebec/gatineau/bumper-to-bumper-gatineau-1401',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/quebec/lile-perrot/bumper-to-bumper-ile-perrot-1413',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/quebec/la-malbaie/bumper-to-bumper-la-malbaie-1380',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/quebec/laval/pieces-dauto-lacroix-inc-1354',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/quebec/longueuil/bumper-to-bumper-st-hubert-5091',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/quebec/mirabel/pieces-dauto-lacroix-inc-1384',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/quebec/montmagny/bumper-to-bumper-montmagny-1365',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/quebec/montreal/bumper-to-bumper-montreal-louis-hebert-1409',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/quebec/montreal/bumper-to-bumper-monteal-est-1421',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/quebec/montreal/montreal-super-store-5067',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/quebec/montreal/bumper-to-bumper-lachine-1412',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/quebec/repentigny/automanie-1596',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/quebec/riviere-du-loup/bumper-to-bumper-riviere-du-loup-1366',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/quebec/saint-eustache/pieces-dauto-lacroix-inc-1356',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/quebec/saint-felicien/bumper-to-bumper-st-felicien-1385',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/quebec/saint-georges/bumper-to-bumper-st-georges-1362',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/quebec/saint-jean-sur-richelieu/btb-pieces-dauto-mb-7-inc-1359',
    to: '/en/find-a-store'
  },
  {
    from: '/en/store-locator/saint-jean-sur-richelieu/mb-7-inc-pieces-dautos-1359',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/quebec/saint-sauveur/pieces-dauto-des-sommets-inc-1428',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/quebec/sainte-marie/bumper-to-bumper-ste-marie-1014-1363',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/quebec/sherbrooke/bumper-to-bumper-king-est-1420',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/quebec/sherbrooke/bumper-to-bumper-sherbrooke-barton-1361',
    to: '/en/find-a-store'
  },
  {
    from: '/en/store-locator/terrebonne/pieces-dautos-lacroix-1355',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/quebec/thetford-mines/bumper-to-bumper-thetford-mines-1364',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/quebec/valcourt/les-pieces-dautomobiles-ferland-inc-1358',
    to: '/en/find-a-store'
  },
  {
    from: '/en/store-locator/benton/newhooks-auto-parts-1977-ltd-1367',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/newfoundland-and-labrador/grand-falls-windsor/brownes-auto-supplies-limited-1426',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/newfoundland-and-labrador/lewisporte/lewisporte-auto-supplies-ltd-1618',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/newfoundland-and-labrador/st-johns/brownes-auto-supplies-ltd-1900',
    to: '/en/find-a-store'
  },
  {
    from: '/en/store-locator/antigonish/cb-hoare-auto-parts-1399',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/nova-scotia/chester/lunenburg-auto-sporting-supply-co-ltd-1371',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/nova-scotia/elmsdale/sangsters-automotive-supplies-1638',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/nova-scotia/lower-sackville/sangsters-automotive-supplies-1637',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/nova-scotia/new-glasgow/bumper-to-bumper-new-glasgow-1400',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/nova-scotia/lunenburg/btb-lunenburg-auto-sporting-supplies-company-ltd-1370',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/nova-scotia/port-hawkesbury/bumper-to-bumper-port-hawkesbury-1398',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/northwest-territories/fort-smith/tdc-contracting-ltd-1331',
    to: '/en/find-a-store'
  },
  {
    from: '/en/store-locator/yellowknife/yellowknife-btb-1351',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/yukon-territory/watson-lake/yukon-supply-inc-5035',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/yukon-territory/whitehorse/bumper-to-bumper-whitehorse-1350',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/new-brunswick/riverview/shur-fit-auto-parts-1432',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/new-brunswick/riverview/shur-fit-auto-parts-1432',
    to: '/en/find-a-store'
  },
  {
    from: '/en/store-locator/riverview/shur-fit-auto-parts-1432',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/new-brunswick/sussex/shur-fit-automotive-1368',
    to: '/en/find-a-store'
  },
  {
    from: '/en/store-locator/sussex/shur-fit-automotive-1368',
    to: '/en/find-a-store'
  },
  {
    from: '/en/store-locator/edmundston/martin-r-albert-inc-1369',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/prince-edward-island/montague/kings-auto-parts-service-ltd-1621',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/prince-edward-island/stratford/kings-auto-parts-service-ltd-5081',
    to: '/en/find-a-store'
  },
  {
    from: '/en/find-a-shop-by-city/prince-edward-island/stratford/kings-auto-parts-service-ltd-5081?utm_source=G&utm_medium=lpm&utm_campaign=bumpertobumper',
    to: ''
  },
  { from: '/en/careers', to: '/en/careers' },
  { from: '/en/contact', to: '/en/contact-us' },
  { from: '/en/services-solutions/for-repair-shops#faq', to: '/en/help' },
  {
    from: '/en/legal/forward-looking-statements',
    to: '/en/privacy-policy'
  },
  {
    from: '/content/images/PDF-copy-Version-177204_2-Privacy-Policy-Final.pdf',
    to: '/en/privacy-policy'
  },
  { from: '/en/legal/terms-of-use', to: '/en/terms-and-conditions' },
  {
    from: '/en/legal/trademark-copyright-information',
    to: '/en/terms-and-conditions'
  },
  {
    from: '/content/images/PDF-copy-Version-177205_2-Terms-of-Use-final.PDF',
    to: '/en/terms-and-conditions'
  },
  { from: '/fr/the-brand-difference', to: '/fr/a-propos-de-nous' },
  { from: '/fr/services-solutions/for-consumer', to: ' /fr/resources/service' },
  {
    from: '/fr/produits-et-equipements-group/liquides',
    to: '/fr/nos-produits'
  },
  {
    from: '/fr/produits-et-equipements-group/outils',
    to: '/fr/nos-produits'
  },
  {
    from: '/fr/produits-et-equipements-group/liquides',
    to: '/fr/nos-produits'
  },
  {
    from: '/fr/produits-et-equipements-group/outils',
    to: '/fr/nos-produits'
  },
  {
    from: '/fr/produits-et-equipements-group/pieces',
    to: '/fr/nos-produits'
  },
  {
    from: '/fr/produits-et-equipements-group/accessoires',
    to: '/fr/nos-produits'
  },
  {
    from: 'http://bumpertobumper.ca/fr/products-equipments/outils',
    to: '/fr/nos-produits'
  },
  { from: '/fr/raybestos', to: '/fr/marques/raybestos' },
  { from: '/fr/rs-parts', to: '/fr/marques/rsparts' },
  { from: '/fr/worldparts', to: '/fr/marques/worldparts' },
  {
    from: '/fr/produits-et-equipements-group/freins-1',
    to: '/fr/nos-produits/freins'
  },
  { from: '/fr/batteries', to: '/fr/nos-produits/batterie' },
  { from: '/fr/news-promotions/news', to: '/fr/ressources' },
  { from: '/fr/news/nascar-horaire-saison-2019', to: '/fr/ressources' },
  {
    from: '/fr/news/kevin-lacroix-finishes-second-at-luxxur-300',
    to: '/fr/ressources'
  },
  {
    from: 'http://www.bumpertobumper.ca/fr/news/lacroix-reprend-la-tete-du-championnat-de-nascar-pintys-a-vallee-jonction',
    to: '/fr/ressources'
  },
  {
    from: '/fr/news/vehicules-hybrides-et-electriques-nouveaux-defis-et-dangers-dans-latelier',
    to: '/fr/ressources'
  },
  {
    from: '/fr/news/cooling-depot-coolant-keeping-your-cars-cool',
    to: '/fr/ressources'
  },
  {
    from: '/fr/news/est-ce-que-votre-air-climatise-est-pret-pour-lete',
    to: '/fr/ressources'
  },
  {
    from: '/fr/news/ascension-parts-pieces-direction-assistee-qualite-programme-ameliore-remboursement-main-oeuv',
    to: '/fr/ressources'
  },
  { from: '/fr/news/nascar-horaire-saison-2019', to: '/fr/ressources' },
  {
    from: '/fr/news/kevin-lacroix-finishes-second-at-luxxur-300',
    to: '/fr/ressources'
  },
  {
    from: '/fr/news/vehicules-hybrides-et-electriques-nouveaux-defis-et-dangers-dans-latelier',
    to: '/fr/ressources'
  },
  {
    from: '/fr/news/cooling-depot-coolant-keeping-your-cars-cool',
    to: '/fr/ressources'
  },
  {
    from: '/fr/news/est-ce-que-votre-air-climatise-est-pret-pour-lete',
    to: '/fr/ressources'
  },
  {
    from: 'http://www.bumpertobumper.ca/fr/news/lacroix-reprend-la-tete-du-championnat-de-nascar-pintys-a-vallee-jonction',
    to: '/fr/ressources'
  },
  {
    from: '/fr/news/ascension-parts-pieces-direction-assistee-qualite-programme-ameliore-remboursement-main-oeuv',
    to: '/fr/ressources'
  },
  { from: '/fr/news/camping-season-is-here', to: '/fr/ressources' },
  { from: '/fr/news/red-rocket-reviered-review', to: '/fr/ressources' },
  {
    from: 'http://www.bumpertobumper.ca/fr/news/kevin-lacroix-bumper-to-bumper-prets-a-conquerir-les-rues-de-toronto',
    to: '/fr/ressources'
  },
  {
    from: 'http://www.bumpertobumper.ca/fr/news/kevin-lacroix-vise-la-victoire-et-rien-de-moins-au-gp3r',
    to: '/fr/ressources'
  },
  {
    from: '/fr/news/the-2018-nascar-season-is-almost-here',
    to: '/fr/ressources'
  },
  {
    from: '/en/news/2019/est-ce-que-votre-air-climatise-est-pret-pour-lete',
    to: '/fr/ressources'
  },
  {
    from: '/fr/promotion/filtres-haute-performance-pour-vehicule-neuf-ou-plus-ancien',
    to: '/fr/ressources'
  },
  {
    from: '/fr/services-solutions/for-wholesalers',
    to: '/fr/pour-votre-magasin'
  },
  {
    from: '/fr/testimonials/nathalie-delisle-garage-delisle',
    to: '/fr/pour-votre-entreprise'
  },
  {
    from: '/fr/training/marketing-solutions',
    to: '/fr/pour-votre-entreprise'
  },
  { from: '/fr/news-promotions/promotions', to: '/fr/circulaire' },
  { from: '/fr/find-a-shop', to: '/fr/trouver-un-magasin' },
  { from: '/fr/find-a-shop-by-city', to: '/fr/trouver-un-magasin' },
  {
    from: '/fr/find-a-shop-by-city/colombie-britannique',
    to: '/fr/trouver-un-magasin'
  },
  { from: '/fr/find-a-shop-by-city/alberta', to: '/fr/trouver-un-magasin' },
  {
    from: '/fr/find-a-shop-by-city/saskatchewan',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/manitoba',
    to: '/fr/trouver-un-magasin'
  },
  { from: '/fr/find-a-shop-by-city/ontario', to: '/fr/trouver-un-magasin' },
  { from: '/fr/find-a-shop-by-city/quebec', to: '/fr/trouver-un-magasin' },
  {
    from: '/fr/find-a-shop-by-city/terre-neuve-labrador',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/territoires-nord-ouest',
    to: '/fr/trouver-un-magasin'
  },
  { from: '/fr/find-a-shop-by-city/yukon', to: '/fr/trouver-un-magasin' },
  {
    from: '/fr/find-a-shop-by-city/nouveau-brunswick',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/ile-prince-edouard',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/nouvelle-ecosse',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/store-locator/null/jbs-saltspring-auto-parts-1312',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/british-columbia/ladysmith/bumper-to-bumper-ladysmith-1314',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/british-columbia/courtenay/bumper-to-bumper-courtenay-1315',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/british-columbia/vancouver/bumper-to-bumper-5th-ave-vancouver-1417',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/british-columbia/quesnel/bumper-to-bumper-quesnel-1382',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/alberta/claresholm/bishoffs-auto-ag-centre-1376',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/alberta/cold-lake/bumper-to-bumper-cold-lake-wilter-auto-industrial-supply-1328',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/alberta/drayton-valley/brians-automotive-specialists-1329',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/alberta/lloydminster/wilter-auto-industrial-supply-lloydminster-1334',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/alberta/nampa/nampa-auto-farm-supply-ltd-1319',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/alberta/olds/motocar-automotive-supply-ltd-1339',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/alberta/plamondon/cs-auto-inc-1316',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/alberta/rocky-mountain-house/rocky-automotive-distributors-ltd-1340',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/alberta/stettler/future-ag-stettler-1983',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/store-locator/whitecourt/downtown-auto-1325',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/store-locator/winnipeg/auto-parts-central-inc-1288',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/ontario/london/bumper-to-bumper-exeter-rd-london-1429',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/quebec/alma/bumper-to-bumper-alma-1383',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/store-locator/alma/pa-jmr-7000570-canada-inc-alma-1383',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/quebec/baie-saint-paul/bumper-to-bumper-la-malbaie-a-baie-st-paul-1379',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/quebec/boisbriand/pieces-dauto-lacroix-inc-1659',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/quebec/east-angus/pieces-dautos-angus-1640',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/quebec/gatineau/bumper-to-bumper-gatineau-1401',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/quebec/laval/pieces-dauto-lacroix-inc-1354',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/quebec/mirabel/pieces-dauto-lacroix-inc-1384',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/quebec/montmagny/bumper-to-bumper-montmagny-1365',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/quebec/montreal/bumper-to-bumper-montreal-louis-hebert-1409',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/store-locator/montreal/bumper-to-bumper-uni-select-quebec-inc-1421',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/quebec/montreal/montreal-super-store-5067',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/quebec/repentigny/automanie-1596',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/quebec/riviere-du-loup/bumper-to-bumper-riviere-du-loup-1366',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/quebec/saint-eustache/pieces-dauto-lacroix-inc-1356',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/quebec/saint-felicien/bumper-to-bumper-st-felicien-1385',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/quebec/saint-georges/bumper-to-bumper-st-georges-1362',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/store-locator/saint-georges/beauce-auto-accessoires-1362',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/quebec/saint-jean-sur-richelieu/btb-pieces-dauto-mb-7-inc-1359',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: 'http://bumpertobumper.ca/fr/store-locator/saint-jean-sur-richelieu/mb-7-inc-pieces-dautos-1359',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/store-locator/saint-sauveur/pieces-dauto-des-sommets-inc-1428',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/quebec/saint-sauveur/pieces-dauto-des-sommets-inc-1428',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/quebec/sainte-marie/bumper-to-bumper-ste-marie-1014-1363',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/quebec/sherbrooke/bumper-to-bumper-king-est-1420',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/quebec/sherbrooke/bumper-to-bumper-sherbrooke-barton-1361',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/quebec/terrebonne/pieces-dauto-lacroix-inc-1355',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/quebec/thetford-mines/bumper-to-bumper-thetford-mines-1364',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/store-locator/valcourt/les-pieces-dautomobiles-ferland-inc-1358',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/nova-scotia/chester/lunenburg-auto-sporting-supply-co-ltd-1371',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/nova-scotia/port-hawkesbury/bumper-to-bumper-port-hawkesbury-1398',
    to: '/fr/trouver-un-magasin'
  },
  {
    from: '/fr/find-a-shop-by-city/nouveau-brunswick/edmundston/btb-martin-r-albert-inc-1369',
    to: '/fr/trouver-un-magasin'
  },
  { from: '/fr/contact', to: '/fr/contactez-nous' },
  {
    from: '/content/images/PDF-copy-Version-177204_2-Privacy-Policy-Final.pdf',
    to: '/fr/politique-de-confidentialite'
  },
  {
    from: '/fr/legal/trademark-copyright-information',
    to: '/fr/termes-et-conditions'
  },
  {
    from: '/fr/legal/forward-looking-statements',
    to: '/fr/termes-et-conditions'
  },
  { from: '/fr/legal/terms-of-use', to: '/fr/termes-et-conditions' },
  {
    from: '/fr/promotion/worldparts-brake-cables',
    to: '/fr/nos-produits/freins?p=1XuoBsqXEAKsUD7KCDvC59'
  },
  {
    to: '/en/find-a-store/store-details/auto-parts-central-inc-812-wall-street-winnipeg',
    from: '/en/find-a-store/store-details?shop=1287'
  },
  {
    to: '/en/find-a-store/store-details/auto-parts-central-inc-1500-regent-avenue-west-winnipeg',
    from: '/en/find-a-store/store-details?shop=1288'
  },
  {
    to: '/en/find-a-store/store-details/auto-parts-central-inc-224-cumberland-street-north-thunder-bay',
    from: '/en/find-a-store/store-details?shop=1289'
  },
  {
    to: '/en/find-a-store/store-details/hb-b-agro-sales-107-cameron-street-foam-lake',
    from: '/en/find-a-store/store-details?shop=1295'
  },
  {
    to: '/en/find-a-store/store-details/jason-s-agri-motive-parts-supply-highway-13',
    from: '/en/find-a-store/store-details?shop=1296'
  },
  {
    to: '/en/find-a-store/store-details/yorkton-ag-auto-supply-63-7-avenue-south-yorkton',
    from: '/en/find-a-store/store-details?shop=1297'
  },
  {
    to: '/en/find-a-store/store-details/tdc-contracting-ltd-1-breynat-street-fort-smith',
    from: '/en/find-a-store/store-details?shop=1331'
  },
  {
    to: '/en/find-a-store/store-details/d-t-auto-center-1998-ltd-816-main-street-north-box-slave-lake',
    from: '/en/find-a-store/store-details?shop=1341'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-falher-942-main-street-southeast-falher',
    from: '/en/find-a-store/store-details?shop=1415'
  },
  {
    to: '/en/find-a-store/store-details/pieces-d-auto-lacroix-inc-2975-boulevard-de-la-piniere-terrebonne',
    from: '/en/find-a-store/store-details?shop=1355'
  },
  {
    to: '/en/find-a-store/store-details/pieces-d-auto-lacroix-inc-825-boulevard-arthur-sauve-saint-eustache',
    from: '/en/find-a-store/store-details?shop=1356'
  },
  {
    to: '/en/find-a-store/store-details/pieces-d-auto-lacroix-inc-14013-boulevard-cure-labelle-mirabel',
    from: '/en/find-a-store/store-details?shop=1384'
  },
  {
    to: '/en/find-a-store/store-details/pieces-d-auto-lacroix-inc-3657-autoroute-jean-noel-lavoie-laval',
    from: '/en/find-a-store/store-details?shop=1354'
  },
  {
    to: '/en/find-a-store/store-details/l-l-auto-ag-supplies-ltd-128-4th-avenue-east-gravelbourg',
    from: '/en/find-a-store/store-details?shop=1292'
  },
  {
    to: '/en/find-a-store/store-details/prairie-parts-plus-ltd-325-1st-avenue-cudworth',
    from: '/en/find-a-store/store-details?shop=1303'
  },
  {
    to: '/en/find-a-store/store-details/btb-lunenburg-auto-sporting-supplies-company-ltd-7-lincoln-street-lunenburg',
    from: '/en/find-a-store/store-details?shop=1370'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-terrace-bay-highway-17-terrace-bay',
    from: '/en/find-a-store/store-details?shop=1285'
  },
  {
    to: '/en/find-a-store/store-details/danielson-s-bumper-to-bumper-provincial-trunk-highway-6-lundar',
    from: '/en/find-a-store/store-details?shop=1282'
  },
  {
    to: '/en/find-a-store/store-details/cs-auto-inc-10050-100-central-e-street-plamondon',
    from: '/en/find-a-store/store-details?shop=1316'
  },
  {
    to: '/en/find-a-store/store-details/jr-s-sales-rentals-2-avenue-west-beaverlodge',
    from: '/en/find-a-store/store-details?shop=1336'
  },
  {
    to: '/en/find-a-store/store-details/beausejour-tire-ltd-751-park-avenue-beausejour',
    from: '/en/find-a-store/store-details?shop=1281'
  },
  {
    to: '/en/find-a-store/store-details/rv-auto-parts-shaunavon-875-3-avenue-west-shaunavon',
    from: '/en/find-a-store/store-details?shop=1304'
  },
  {
    to: '/en/find-a-store/store-details/lewisporte-auto-supplies-ltd-437-main-street-lewisporte',
    from: '/en/find-a-store/store-details?shop=1618'
  },
  {
    to: '/en/find-a-store/store-details/assiniboia-auto-parts-ltd-101-2nd-avenue-east-assiniboia',
    from: '/en/find-a-store/store-details?shop=1441'
  },
  {
    to: '/en/find-a-store/store-details/sangster-s-automotive-supplies-622-nova-scotia-trunk-2-elmsdale',
    from: '/en/find-a-store/store-details?shop=1638'
  },
  {
    to: '/en/find-a-store/store-details/leroux-auto-parts-3576-errington-avenue-north-sudbury',
    from: '/en/find-a-store/store-details?shop=1644'
  },
  {
    to: '/en/find-a-store/store-details/pieces-d-auto-lacroix-inc-800-boulevard-du-cure-boivin-boisbriand',
    from: '/en/find-a-store/store-details?shop=1659'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-sherbrooke-barton-310-rue-barton-sherbrooke',
    from: '/en/find-a-store/store-details?shop=1361'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-king-est-3545-rue-king-est-sherbrooke',
    from: '/en/find-a-store/store-details?shop=1420'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-antigonish-73-saint-andrews-street-antigonish',
    from: '/en/find-a-store/store-details?shop=1399'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-new-hamburg-100-bergey-court-new-hamburg',
    from: '/en/find-a-store/store-details?shop=1407'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-port-hawkesbury-634-reeves-street-port-hawkesbury',
    from: '/en/find-a-store/store-details?shop=1398'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-new-glasgow-980-east-river-road-new-glasgow',
    from: '/en/find-a-store/store-details?shop=1400'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-penticton-300-okanagan-avenue-east-penticton',
    from: '/en/find-a-store/store-details?shop=1419'
  },
  {
    to: '/en/find-a-store/store-details/sioux-per-auto-parts-inc-122-alcona-drive-sioux-lookout',
    from: '/en/find-a-store/store-details?shop=1290'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-exeter-rd-london-765-exeter-road-london',
    from: '/en/find-a-store/store-details?shop=1429'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-roper-rd-edmonton-8548-roper-road-northwest-edmonton',
    from: '/en/find-a-store/store-details?shop=1633'
  },
  {
    to: '/en/find-a-store/store-details/lunenburg-auto-sporting-supply-co-ltd--chester',
    from: '/en/find-a-store/store-details?shop=1371'
  },
  {
    to: '/en/find-a-store/store-details/automanie-597-rue-notre-dame-repentigny',
    from: '/en/find-a-store/store-details?shop=1596'
  },
  {
    to: '/en/find-a-store/store-details/1st-stop-auto-parts-ind-supply-inc-3010a-box-3760-w-green-cter---hwy-humboldt',
    from: '/en/find-a-store/store-details?shop=1389'
  },
  {
    to: '/en/find-a-store/store-details/extreme-speed-rv-ltd-101-9th-street-west-meadow-lake',
    from: '/en/find-a-store/store-details?shop=1307'
  },
  {
    to: '/en/find-a-store/store-details/btb-martin-r-albert-inc-22-chemin-du-pouvoir-edmundston',
    from: '/en/find-a-store/store-details?shop=1369'
  },
  {
    to: '/en/find-a-store/store-details/browne-s-auto-supplies-limited-1-queensway-industrial-park-grand-falls-windsor',
    from: '/en/find-a-store/store-details?shop=1426'
  },
  {
    to: '/en/find-a-store/store-details/pieces-d-autos-angus-230-rue-angus-sud-east-angus',
    from: '/en/find-a-store/store-details?shop=1640'
  },
  {
    to: '/en/find-a-store/store-details/pieces-d-auto-des-sommets-inc-390-rue-principale-saint-sauveur',
    from: '/en/find-a-store/store-details?shop=1428'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-kindersley-202-a-12-avenue-east-kindersley',
    from: '/en/find-a-store/store-details?shop=1305'
  },
  {
    to: '/en/find-a-store/store-details/btb-three-hills-motor-products-ltd-301-2-street-north-three-hills',
    from: '/en/find-a-store/store-details?shop=1372'
  },
  {
    to: '/en/find-a-store/store-details/les-pieces-d-automobiles-ferland-inc-1124-rue-saint-joseph-valcourt',
    from: '/en/find-a-store/store-details?shop=1358'
  },
  {
    to: '/en/find-a-store/store-details/kings-auto-parts-service-ltd-5206-highway-a-a-macdonald-montague',
    from: '/en/find-a-store/store-details?shop=1621'
  },
  {
    to: '/en/find-a-store/store-details/sangster-s-automotive-supplies-668-sackville-drive-lower-sackville',
    from: '/en/find-a-store/store-details?shop=1637'
  },
  {
    to: '/en/find-a-store/store-details/btb-thind-brothers-12245-fort-road-northwest-edmonton',
    from: '/en/find-a-store/store-details?shop=1387'
  },
  {
    to: '/en/find-a-store/store-details/dale-s-auto-industrial-supply-ltd-5006-railway-avenue-glendon',
    from: '/en/find-a-store/store-details?shop=1323'
  },
  {
    to: '/en/find-a-store/store-details/bauer-auto-tire-ltd-4704-50-avenue-mannville',
    from: '/en/find-a-store/store-details?shop=1352'
  },
  {
    to: '/en/find-a-store/store-details/btb-two-hills-auto-industrial-supply-ltd-4909-55-avenue-two-hills',
    from: '/en/find-a-store/store-details?shop=1392'
  },
  {
    to: '/en/find-a-store/store-details/btb-veg-auto-industrial-supply-2013-ltd-4821-50-avenue-vegreville',
    from: '/en/find-a-store/store-details?shop=1393'
  },
  {
    to: '/en/find-a-store/store-details/lc-auto-ag-ltd-104-carl-avenue-east-langenburg',
    from: '/en/find-a-store/store-details?shop=1293'
  },
  {
    to: '/en/find-a-store/store-details/universal-parts-supply-tam-ind-460-saskatchewan-3-hudson-bay',
    from: '/en/find-a-store/store-details?shop=1306'
  },
  {
    to: '/en/find-a-store/store-details/elmac-auto-electric-ltd-6290-67a-street-red-deer',
    from: '/en/find-a-store/store-details?shop=1320'
  },
  {
    to: '/en/find-a-store/store-details/woodland-lumber-building-supplies-53314-range-road-75a-evansburg',
    from: '/en/find-a-store/store-details?shop=1406'
  },
  {
    to: '/en/find-a-store/store-details/btb-ok-ag-auto-parts-303-railway-street-kipling',
    from: '/en/find-a-store/store-details?shop=1427'
  },
  {
    to: '/en/find-a-store/store-details/yh-truck-ag-auto-105-saskatchewan-14-biggar',
    from: '/en/find-a-store/store-details?shop=5079'
  },
  {
    to: '/en/find-a-store/store-details/kings-auto-parts-service-ltd-10-myrtle-street-stratford',
    from: '/en/find-a-store/store-details?shop=5081'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-montreal-est-7330-avenue-rene-descartes-montreal',
    from: '/en/find-a-store/store-details?shop=1421'
  },
  {
    to: '/en/find-a-store/store-details/wismer-s-auto-parts-plus-888-dundas-street-woodstock',
    from: '/en/find-a-store/store-details?shop=1381'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-he-brown-supply-600-gormanville-road-north-bay',
    from: '/en/find-a-store/store-details?shop=1397'
  },
  {
    to: '/en/find-a-store/store-details/fernie-auto-parts-ltd-2-manitou-road-fernie',
    from: '/en/find-a-store/store-details?shop=1476'
  },
  {
    to: '/en/find-a-store/store-details/btb-uxbridge-241-main-street-north-uxbridge',
    from: '/en/find-a-store/store-details?shop=1424'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-sunderland-highway-7-sunderland',
    from: '/en/find-a-store/store-details?shop=1423'
  },
  {
    to: '/en/find-a-store/store-details/lc-auto-ag-ltd-2020-service-road-rocanville',
    from: '/en/find-a-store/store-details?shop=1294'
  },
  {
    to: '/en/find-a-store/store-details/browne-s-auto-supplies-ltd-25-hebron-way-st-john-s',
    from: '/en/find-a-store/store-details?shop=1900'
  },
  {
    to: '/en/find-a-store/store-details/btb-pieces-d-auto-mb-7-inc-410-16e-avenue-saint-jean-sur-richelieu',
    from: '/en/find-a-store/store-details?shop=1359'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-owen-sound-222-14th-street-west-owen-sound',
    from: '/en/find-a-store/store-details?shop=1431'
  },
  {
    to: '/en/find-a-store/store-details/macklin-auto-centre-1994-5304-46-street-macklin',
    from: '/en/find-a-store/store-details?shop=1300'
  },
  {
    to: '/en/find-a-store/store-details/great-west-auto-electric-ltd-111-chaplin-street-west-swift-current',
    from: '/en/find-a-store/store-details?shop=1483'
  },
  {
    to: '/en/find-a-store/store-details/northern-lites-auto-farm-supply-14-provincial-trunk-highway-6-ashern',
    from: '/en/find-a-store/store-details?shop=1280'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-118th-ave-edmonton-15935-118-avenue-northwest-edmonton',
    from: '/en/find-a-store/store-details?shop=1635'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-chemainus-3107-henry-road-chemainus',
    from: '/en/find-a-store/store-details?shop=1403'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-main-street-north-vancouver-1425-main-street-north-vancouver',
    from: '/en/find-a-store/store-details?shop=1298'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-1st-street-north-vancouver-850-west-1st-street-north-vancouver',
    from: '/en/find-a-store/store-details?shop=1299'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-whitehorse-306-ray-street-whitehorse',
    from: '/en/find-a-store/store-details?shop=1350'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-cremona-126-2-street-west-cremona',
    from: '/en/find-a-store/store-details?shop=1377'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-st-georges-325-107e-rue-saint-georges',
    from: '/en/find-a-store/store-details?shop=1362'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-ste-marie-1014-245-route-chasse-sainte-marie',
    from: '/en/find-a-store/store-details?shop=1363'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-thetford-mines-1345-boulevard-frontenac-est-thetford-mines',
    from: '/en/find-a-store/store-details?shop=1364'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-montmagny-130-boulevard-tache-ouest-montmagny',
    from: '/en/find-a-store/store-details?shop=1365'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-riviere-du-loup-374-rue-temiscouata-riviere-du-loup',
    from: '/en/find-a-store/store-details?shop=1366'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-alma-225-avenue-du-pont-sud-alma',
    from: '/en/find-a-store/store-details?shop=1383'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-st-felicien-739-boulevard-du-sacre-coeur-saint-felicien',
    from: '/en/find-a-store/store-details?shop=1385'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-la-malbaie-1975-boulevard-de-comporte-la-malbaie',
    from: '/en/find-a-store/store-details?shop=1380'
  },
  {
    to: '/en/find-a-store/store-details/daysland-auto-farm-supply-5108-50-avenue-daysland',
    from: '/en/find-a-store/store-details?shop=1395'
  },
  {
    to: '/en/find-a-store/store-details/first-place-auto-parts-ltd-10108-107-street-westlock',
    from: '/en/find-a-store/store-details?shop=1347'
  },
  {
    to: '/en/find-a-store/store-details/brian-s-automotive-specialists-5611-50-avenue-drayton-valley',
    from: '/en/find-a-store/store-details?shop=1329'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-edmonton-south-3731-99-street-northwest-edmonton',
    from: '/en/find-a-store/store-details?shop=1318'
  },
  {
    to: '/en/find-a-store/store-details/btb-par-auto-parts-airdrie-ltd-4-east-lake-avenue-northeast-airdrie',
    from: '/en/find-a-store/store-details?shop=1374'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-hanna-220-1-avenue-west-hanna',
    from: '/en/find-a-store/store-details?shop=1332'
  },
  {
    to: '/en/find-a-store/store-details/bishoff-s-auto-ag-centre-4223-3-street-east-claresholm',
    from: '/en/find-a-store/store-details?shop=1376'
  },
  {
    to: '/en/find-a-store/store-details/wainwright-auto-supply-1988-ltd-5107-50-street-viking',
    from: '/en/find-a-store/store-details?shop=1349'
  },
  {
    to: '/en/find-a-store/store-details/wainwright-auto-supply-1988-ltd-1801-14-avenue-wainwright',
    from: '/en/find-a-store/store-details?shop=1346'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-fort-nelson-g-and-o-supply-ltd-4516-50-avenue-north-fort-nelson',
    from: '/en/find-a-store/store-details?shop=1330'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-salt-spring-106-jackson-avenue',
    from: '/en/find-a-store/store-details?shop=1312'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-quesnel-156-malcolm-drive-quesnel',
    from: '/en/find-a-store/store-details?shop=1382'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-government-2017-government-street-victoria',
    from: '/en/find-a-store/store-details?shop=1313'
  },
  {
    to: '/en/find-a-store/store-details/wilter-auto-industrial-supply-bonnyville-5502-52-avenue-bonnyville',
    from: '/en/find-a-store/store-details?shop=1337'
  },
  {
    to: '/en/find-a-store/store-details/wilter-auto-industrial-supply-elk-point-5901-48-street-elk-point',
    from: '/en/find-a-store/store-details?shop=1344'
  },
  {
    to: '/en/find-a-store/store-details/wilter-auto-industrial-supply-st-paul-4409-50-avenue-saint-paul',
    from: '/en/find-a-store/store-details?shop=1343'
  },
  {
    to: '/en/find-a-store/store-details/wilter-auto-industrial-supply-lloydminster-3502-50-avenue-lloydminster',
    from: '/en/find-a-store/store-details?shop=1334'
  },
  {
    to: '/en/find-a-store/store-details/btb-lacombe-wilter-auto-industrial-supply-5620-len-thompson-drive-lacombe',
    from: '/en/find-a-store/store-details?shop=1353'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-cold-lake-wilter-auto-industrial-supply-5609-55-street-cold-lake',
    from: '/en/find-a-store/store-details?shop=1328'
  },
  {
    to: '/en/find-a-store/store-details/saanichton-1709-6777-kirkpatrick-crescent-saanichton',
    from: '/en/find-a-store/store-details?shop=5044'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-hankin-st-thorsby-4840-hankin-street-thorsby',
    from: '/en/find-a-store/store-details?shop=1634'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-la-malbaie-a-baie-st-paul-1048-boulevard-monseigneur-de-laval-baie-saint-paul',
    from: '/en/find-a-store/store-details?shop=1379'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-gatineau-650-boulevard-maloney-est-gatineau',
    from: '/en/find-a-store/store-details?shop=1401'
  },
  {
    to: '/en/find-a-store/store-details/nampa-auto-farm-supply-ltd-alberta-2-nampa',
    from: '/en/find-a-store/store-details?shop=1319'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-sundre-28-5445-box-1679-highway-584-west-sundre',
    from: '/en/find-a-store/store-details?shop=1422'
  },
  {
    to: '/en/find-a-store/store-details/rocky-automotive-distributors-ltd-4615-45-street-rocky-mountain-house',
    from: '/en/find-a-store/store-details?shop=1340'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-edson-4804-3-avenue-edson',
    from: '/en/find-a-store/store-details?shop=1322'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-gold-stream-ave-895-goldstream-avenue-victoria',
    from: '/en/find-a-store/store-details?shop=1310'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-5th-ave-vancouver-133-west-5th-avenue-vancouver',
    from: '/en/find-a-store/store-details?shop=1417'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-lachine-668-1re-avenue-montreal',
    from: '/en/find-a-store/store-details?shop=1412'
  },
  {
    to: '/en/find-a-store/store-details/yukon-supply-inc-406-adela-trail-watson-lake',
    from: '/en/find-a-store/store-details?shop=5035'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-st-hubert-6860-grande-allee-longueuil',
    from: '/en/find-a-store/store-details?shop=5091'
  },
  {
    to: '/en/find-a-store/store-details/shur-fit-automotive-1575-riverview-drive-east-sussex',
    from: '/en/find-a-store/store-details?shop=1368'
  },
  {
    to: '/en/find-a-store/store-details/shur-fit-auto-parts-121-pine-glen-road-riverview',
    from: '/en/find-a-store/store-details?shop=1432'
  },
  {
    to: '/en/find-a-store/store-details/yellowknife-bumper-to-bumper-316-woolgar-avenue-yellowknife',
    from: '/en/find-a-store/store-details?shop=1351'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-ladysmith-1146-rocky-creek-road-ladysmith',
    from: '/en/find-a-store/store-details?shop=1314'
  },
  {
    to: '/en/find-a-store/store-details/motocar-automotive-supply-ltd-4610-46-avenue-olds',
    from: '/en/find-a-store/store-details?shop=1339'
  },
  {
    to: '/en/find-a-store/store-details/agi---bumper-to-bumper-edmonton-11750-170-street-northwest-edmonton',
    from: '/en/find-a-store/store-details?shop=1317'
  },
  {
    to: '/en/find-a-store/store-details/all-rig-services-ltd-137-wheatland-avenue-smoky-lake',
    from: '/en/find-a-store/store-details?shop=1342'
  },
  {
    to: '/en/find-a-store/store-details/quality-auto-supply-149-orchard-park-road-strathmore',
    from: '/en/find-a-store/store-details?shop=1378'
  },
  {
    to: '/en/find-a-store/store-details/reno-s-automotive-ltd-4515-56-street-wetaskiwin',
    from: '/en/find-a-store/store-details?shop=5090'
  },
  {
    to: '/en/find-a-store/store-details/industrial-ag-supplies-5021-44-avenue-innisfail',
    from: '/en/find-a-store/store-details?shop=5039'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-whitecourt-downtown-auto-5015-50-avenue-whitecourt',
    from: '/en/find-a-store/store-details?shop=1325'
  },
  {
    to: '/en/find-a-store/store-details/swan-valley-auto-ltd-1506-3-street-north-swan-river',
    from: '/en/find-a-store/store-details?shop=1291'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-fort-mcmurray-223-macalpine-crescent-fort-mcmurray',
    from: '/en/find-a-store/store-details?shop=1642'
  },
  {
    to: '/en/find-a-store/store-details/sutherland-automotive-433-south-industrial-drive-prince-albert',
    from: '/en/find-a-store/store-details?shop=2036'
  },
  {
    to: '/en/find-a-store/store-details/sutherland-automotive-242-river-street-west-moose-jaw',
    from: '/en/find-a-store/store-details?shop=2223'
  },
  {
    to: '/en/find-a-store/store-details/sutherland-automotive-1242-102-street-north-battleford',
    from: '/en/find-a-store/store-details?shop=5053'
  },
  {
    to: '/en/find-a-store/store-details/sutherland-automotive-2802-cleveland-avenue-saskatoon',
    from: '/en/find-a-store/store-details?shop=2183'
  },
  {
    to: '/en/find-a-store/store-details/bounty-onsite-inc-4204-38-street-stettler',
    from: '/en/find-a-store/store-details?shop=1321'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-duncan-5829-duncan-street-duncan',
    from: '/en/find-a-store/store-details?shop=1402'
  },
  {
    to: '/en/find-a-store/store-details/newhook-s-auto-parts-1977-ltd-120-roe-avenue-gander',
    from: '/en/find-a-store/store-details?shop=1367'
  },
  {
    to: '/en/find-a-store/store-details/morinville-bumper-to-bumper-10031-100-avenue-morinville',
    from: '/en/find-a-store/store-details?shop=1338'
  },
  {
    to: '/en/find-a-store/store-details/btb-gilbert-supply-company-ltd-874-notre-dame-drive-kamloops',
    from: '/en/find-a-store/store-details?shop=5134'
  },
  {
    to: '/en/find-a-store/store-details/btb-gilbert-supply-company-ltd-2051-granite-avenue-merritt',
    from: '/en/find-a-store/store-details?shop=5135'
  },
  {
    to: '/en/find-a-store/store-details/agi---bumper-to-bumper-calgary-1710-104-avenue-northeast-calgary',
    from: '/en/find-a-store/store-details?shop=1373'
  },
  {
    to: '/en/find-a-store/store-details/rv-auto-parts-frontier-112-second-avenue-frontier',
    from: '/en/find-a-store/store-details?shop=1607'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumperanderson-auto-parts-supplies-ltd-5907-49-street-barrhead',
    from: '/en/find-a-store/store-details?shop=5144'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-mayerthorpe-4814-crockett-50-street-mayerthorpe',
    from: '/en/find-a-store/store-details?shop=1425'
  },
  {
    to: '/en/find-a-store/store-details/montreal-super-store-6818-rue-jarry-est-montreal',
    from: '/en/find-a-store/store-details?shop=5067'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-montreal-louis-hebert-5660-avenue-louis-hebert-montreal',
    from: '/en/find-a-store/store-details?shop=1409'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-thibault-s-auto-ltd-273-centre-street-ponteix',
    from: '/en/find-a-store/store-details?shop=5162'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-courtenay-480-puntledge-road-courtenay',
    from: '/en/find-a-store/store-details?shop=1315'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-orillia-1861-73-memorial-avenue-orillia',
    from: '/en/find-a-store/store-details?shop=5176'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-barrie-1860-90-anne-street-south-barrie',
    from: '/en/find-a-store/store-details?shop=1467'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-innisfil-1862-7905-yonge-street-innisfil',
    from: '/en/find-a-store/store-details?shop=5175'
  },
  {
    to: '/en/find-a-store/store-details/gilbert-supply-company-1220-a-waddington-drive-vernon',
    from: '/en/find-a-store/store-details?shop=1994'
  },
  {
    to: '/en/find-a-store/store-details/du-so-jac-sil-inc-377-rue-dupuy-quebec',
    from: '/en/find-a-store/store-details?shop=1474'
  },
  {
    to: '/en/find-a-store/store-details/du-so-jac-sil-inc-1760-route-de-l-aeroport-quebec',
    from: '/en/find-a-store/store-details?shop=1473'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumper-du-so-jac-sil-inc-beauport-433-boulevard-armand-paris-quebec',
    from: '/en/find-a-store/store-details?shop=5187'
  },
  {
    to: '/en/find-a-store/store-details/du-so-jac-sil-inc---succursale-rive-sud-731-rue-de-saint-romuald-levis',
    from: '/en/find-a-store/store-details?shop=5181'
  },
  {
    to: '/en/find-a-store/store-details/bumper-to-bumperhb-b-agro-sales-107-cameron-street-foam-lake',
    from: '/en/find-a-store/store-details?shop=5130'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/auto-parts-central-inc-1239-amber-drive-thunder-bay',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1286'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/auto-parts-central-inc-812-wall-street-winnipeg',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1287'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/auto-parts-central-inc-1500-regent-avenue-west-winnipeg',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1288'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/auto-parts-central-inc-224-cumberland-street-north-thunder-bay',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1289'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/hb-b-agro-sales-107-cameron-street-foam-lake',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1295'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/jason-s-agri-motive-parts-supply-highway-13',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1296'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/yorkton-ag-auto-supply-63-7-avenue-south-yorkton',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1297'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/tdc-contracting-ltd-1-breynat-street-fort-smith',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1331'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/d-t-auto-center-1998-ltd-816-main-street-north-box-slave-lake',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1341'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-falher-942-main-street-southeast-falher',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1415'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/pieces-d-auto-lacroix-inc-2975-boulevard-de-la-piniere-terrebonne',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1355'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/pieces-d-auto-lacroix-inc-825-boulevard-arthur-sauve-saint-eustache',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1356'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/pieces-d-auto-lacroix-inc-14013-boulevard-cure-labelle-mirabel',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1384'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/pieces-d-auto-lacroix-inc-3657-autoroute-jean-noel-lavoie-laval',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1354'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/l-l-auto-ag-supplies-ltd-128-4th-avenue-east-gravelbourg',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1292'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/prairie-parts-plus-ltd-325-1st-avenue-cudworth',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1303'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/btb-lunenburg-auto-sporting-supplies-company-ltd-7-lincoln-street-lunenburg',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1370'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-terrace-bay-highway-17-terrace-bay',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1285'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/danielson-s-bumper-to-bumper-provincial-trunk-highway-6-lundar',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1282'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/cs-auto-inc-10050-100-central-e-street-plamondon',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1316'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/jr-s-sales-rentals-2-avenue-west-beaverlodge',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1336'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/beausejour-tire-ltd-751-park-avenue-beausejour',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1281'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/rv-auto-parts-shaunavon-875-3-avenue-west-shaunavon',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1304'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/lewisporte-auto-supplies-ltd-437-main-street-lewisporte',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1618'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/assiniboia-auto-parts-ltd-101-2nd-avenue-east-assiniboia',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1441'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/sangster-s-automotive-supplies-622-nova-scotia-trunk-2-elmsdale',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1638'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/leroux-auto-parts-3576-errington-avenue-north-sudbury',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1644'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/pieces-d-auto-lacroix-inc-800-boulevard-du-cure-boivin-boisbriand',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1659'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-sherbrooke-barton-310-rue-barton-sherbrooke',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1361'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-king-est-3545-rue-king-est-sherbrooke',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1420'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-antigonish-73-saint-andrews-street-antigonish',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1399'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-new-hamburg-100-bergey-court-new-hamburg',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1407'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-port-hawkesbury-634-reeves-street-port-hawkesbury',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1398'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-new-glasgow-980-east-river-road-new-glasgow',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1400'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-penticton-300-okanagan-avenue-east-penticton',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1419'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/sioux-per-auto-parts-inc-122-alcona-drive-sioux-lookout',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1290'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-exeter-rd-london-765-exeter-road-london',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1429'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-roper-rd-edmonton-8548-roper-road-northwest-edmonton',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1633'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/lunenburg-auto-sporting-supply-co-ltd--chester',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1371'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/automanie-597-rue-notre-dame-repentigny',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1596'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/1st-stop-auto-parts-ind-supply-inc-3010a-box-3760-w-green-cter---hwy-humboldt',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1389'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/extreme-speed-rv-ltd-101-9th-street-west-meadow-lake',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1307'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/btb-martin-r-albert-inc-22-chemin-du-pouvoir-edmundston',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1369'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/browne-s-auto-supplies-limited-1-queensway-industrial-park-grand-falls-windsor',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1426'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/pieces-d-autos-angus-230-rue-angus-sud-east-angus',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1640'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/pieces-d-auto-des-sommets-inc-390-rue-principale-saint-sauveur',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1428'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-kindersley-202-a-12-avenue-east-kindersley',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1305'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/btb-three-hills-motor-products-ltd-301-2-street-north-three-hills',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1372'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/les-pieces-d-automobiles-ferland-inc-1124-rue-saint-joseph-valcourt',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1358'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/kings-auto-parts-service-ltd-5206-highway-a-a-macdonald-montague',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1621'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/sangster-s-automotive-supplies-668-sackville-drive-lower-sackville',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1637'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/btb-thind-brothers-12245-fort-road-northwest-edmonton',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1387'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/dale-s-auto-industrial-supply-ltd-5006-railway-avenue-glendon',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1323'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bauer-auto-tire-ltd-4704-50-avenue-mannville',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1352'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/btb-two-hills-auto-industrial-supply-ltd-4909-55-avenue-two-hills',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1392'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/btb-veg-auto-industrial-supply-2013-ltd-4821-50-avenue-vegreville',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1393'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/lc-auto-ag-ltd-104-carl-avenue-east-langenburg',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1293'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/universal-parts-supply-tam-ind-460-saskatchewan-3-hudson-bay',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1306'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/elmac-auto-electric-ltd-6290-67a-street-red-deer',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1320'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/woodland-lumber-building-supplies-53314-range-road-75a-evansburg',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1406'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/btb-ok-ag-auto-parts-303-railway-street-kipling',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1427'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/yh-truck-ag-auto-105-saskatchewan-14-biggar',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=5079'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/kings-auto-parts-service-ltd-10-myrtle-street-stratford',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=5081'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-montreal-est-7330-avenue-rene-descartes-montreal',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1421'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/wismer-s-auto-parts-plus-888-dundas-street-woodstock',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1381'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-he-brown-supply-600-gormanville-road-north-bay',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1397'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/fernie-auto-parts-ltd-2-manitou-road-fernie',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1476'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/btb-uxbridge-241-main-street-north-uxbridge',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1424'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-sunderland-highway-7-sunderland',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1423'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/lc-auto-ag-ltd-2020-service-road-rocanville',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1294'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/browne-s-auto-supplies-ltd-25-hebron-way-st-john-s',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1900'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/btb-pieces-d-auto-mb-7-inc-410-16e-avenue-saint-jean-sur-richelieu',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1359'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-owen-sound-222-14th-street-west-owen-sound',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1431'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/macklin-auto-centre-1994-5304-46-street-macklin',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1300'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/great-west-auto-electric-ltd-111-chaplin-street-west-swift-current',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1483'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/northern-lites-auto-farm-supply-14-provincial-trunk-highway-6-ashern',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1280'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-118th-ave-edmonton-15935-118-avenue-northwest-edmonton',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1635'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-chemainus-3107-henry-road-chemainus',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1403'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-main-street-north-vancouver-1425-main-street-north-vancouver',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1298'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-1st-street-north-vancouver-850-west-1st-street-north-vancouver',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1299'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-whitehorse-306-ray-street-whitehorse',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1350'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-cremona-126-2-street-west-cremona',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1377'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-st-georges-325-107e-rue-saint-georges',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1362'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-ste-marie-1014-245-route-chasse-sainte-marie',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1363'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-thetford-mines-1345-boulevard-frontenac-est-thetford-mines',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1364'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-montmagny-130-boulevard-tache-ouest-montmagny',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1365'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-riviere-du-loup-374-rue-temiscouata-riviere-du-loup',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1366'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-alma-225-avenue-du-pont-sud-alma',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1383'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-st-felicien-739-boulevard-du-sacre-coeur-saint-felicien',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1385'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-la-malbaie-1975-boulevard-de-comporte-la-malbaie',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1380'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/daysland-auto-farm-supply-5108-50-avenue-daysland',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1395'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/first-place-auto-parts-ltd-10108-107-street-westlock',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1347'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/brian-s-automotive-specialists-5611-50-avenue-drayton-valley',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1329'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-edmonton-south-3731-99-street-northwest-edmonton',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1318'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/btb-par-auto-parts-airdrie-ltd-4-east-lake-avenue-northeast-airdrie',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1374'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-hanna-220-1-avenue-west-hanna',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1332'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bishoff-s-auto-ag-centre-4223-3-street-east-claresholm',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1376'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/wainwright-auto-supply-1988-ltd-5107-50-street-viking',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1349'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/wainwright-auto-supply-1988-ltd-1801-14-avenue-wainwright',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1346'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-fort-nelson-g-and-o-supply-ltd-4516-50-avenue-north-fort-nelson',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1330'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-salt-spring-106-jackson-avenue',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1312'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-quesnel-156-malcolm-drive-quesnel',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1382'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-government-2017-government-street-victoria',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1313'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/wilter-auto-industrial-supply-bonnyville-5502-52-avenue-bonnyville',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1337'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/wilter-auto-industrial-supply-elk-point-5901-48-street-elk-point',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1344'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/wilter-auto-industrial-supply-st-paul-4409-50-avenue-saint-paul',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1343'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/wilter-auto-industrial-supply-lloydminster-3502-50-avenue-lloydminster',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1334'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/btb-lacombe-wilter-auto-industrial-supply-5620-len-thompson-drive-lacombe',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1353'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-cold-lake-wilter-auto-industrial-supply-5609-55-street-cold-lake',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1328'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/saanichton-1709-6777-kirkpatrick-crescent-saanichton',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=5044'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-hankin-st-thorsby-4840-hankin-street-thorsby',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1634'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-la-malbaie-a-baie-st-paul-1048-boulevard-monseigneur-de-laval-baie-saint-paul',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1379'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-gatineau-650-boulevard-maloney-est-gatineau',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1401'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/nampa-auto-farm-supply-ltd-alberta-2-nampa',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1319'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-sundre-28-5445-box-1679-highway-584-west-sundre',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1422'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/rocky-automotive-distributors-ltd-4615-45-street-rocky-mountain-house',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1340'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-edson-4804-3-avenue-edson',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1322'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-gold-stream-ave-895-goldstream-avenue-victoria',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1310'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-5th-ave-vancouver-133-west-5th-avenue-vancouver',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1417'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-lachine-668-1re-avenue-montreal',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1412'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/yukon-supply-inc-406-adela-trail-watson-lake',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=5035'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-st-hubert-6860-grande-allee-longueuil',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=5091'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/shur-fit-automotive-1575-riverview-drive-east-sussex',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1368'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/shur-fit-auto-parts-121-pine-glen-road-riverview',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1432'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/yellowknife-bumper-to-bumper-316-woolgar-avenue-yellowknife',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1351'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-ladysmith-1146-rocky-creek-road-ladysmith',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1314'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/motocar-automotive-supply-ltd-4610-46-avenue-olds',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1339'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/agi---bumper-to-bumper-edmonton-11750-170-street-northwest-edmonton',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1317'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/all-rig-services-ltd-137-wheatland-avenue-smoky-lake',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1342'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/quality-auto-supply-149-orchard-park-road-strathmore',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1378'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/reno-s-automotive-ltd-4515-56-street-wetaskiwin',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=5090'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/industrial-ag-supplies-5021-44-avenue-innisfail',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=5039'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-whitecourt-downtown-auto-5015-50-avenue-whitecourt',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1325'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/swan-valley-auto-ltd-1506-3-street-north-swan-river',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1291'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-fort-mcmurray-223-macalpine-crescent-fort-mcmurray',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1642'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/sutherland-automotive-433-south-industrial-drive-prince-albert',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=2036'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/sutherland-automotive-242-river-street-west-moose-jaw',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=2223'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/sutherland-automotive-1242-102-street-north-battleford',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=5053'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/sutherland-automotive-2802-cleveland-avenue-saskatoon',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=2183'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bounty-onsite-inc-4204-38-street-stettler',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1321'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-duncan-5829-duncan-street-duncan',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1402'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/newhook-s-auto-parts-1977-ltd-120-roe-avenue-gander',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1367'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/morinville-bumper-to-bumper-10031-100-avenue-morinville',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1338'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/btb-gilbert-supply-company-ltd-874-notre-dame-drive-kamloops',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=5134'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/btb-gilbert-supply-company-ltd-2051-granite-avenue-merritt',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=5135'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/agi---bumper-to-bumper-calgary-1710-104-avenue-northeast-calgary',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1373'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/rv-auto-parts-frontier-112-second-avenue-frontier',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1607'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumperanderson-auto-parts-supplies-ltd-5907-49-street-barrhead',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=5144'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-mayerthorpe-4814-crockett-50-street-mayerthorpe',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1425'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/montreal-super-store-6818-rue-jarry-est-montreal',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=5067'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-montreal-louis-hebert-5660-avenue-louis-hebert-montreal',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1409'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-thibault-s-auto-ltd-273-centre-street-ponteix',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=5162'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-courtenay-480-puntledge-road-courtenay',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1315'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-orillia-1861-73-memorial-avenue-orillia',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=5176'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-barrie-1860-90-anne-street-south-barrie',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1467'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-innisfil-1862-7905-yonge-street-innisfil',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=5175'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/gilbert-supply-company-1220-a-waddington-drive-vernon',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1994'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/du-so-jac-sil-inc-377-rue-dupuy-quebec',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1474'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/du-so-jac-sil-inc-1760-route-de-l-aeroport-quebec',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=1473'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumper-du-so-jac-sil-inc-beauport-433-boulevard-armand-paris-quebec',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=5187'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/du-so-jac-sil-inc---succursale-rive-sud-731-rue-de-saint-romuald-levis',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=5181'
  },
  {
    to: '/fr/trouver-un-magasin/magasin-detail/bumper-to-bumperhb-b-agro-sales-107-cameron-street-foam-lake',
    from: '/fr/trouver-un-magasin/magasin-detail?shop=5130'
  }
]
